import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCarrierActivities extends Layout {
    labelPastDue: Label;
    labelToday: Label;
    labelPastDueCount: Label;
    labelTodayCount: Label;
    labelTotal: Label;
    labelTotalCount: Label;
    panelToday: Panel;
    panelTotal: Panel;
    sourceCarrierSales: DataSource;
}
